import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { ITableColumnHeader } from "src/app/models/table-column-header";
import { ApiService } from "src/app/providers/api.service";
import { DialogService } from "src/app/providers/dialog.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { InvoiceForReportOnlyComponent } from "src/app/shared/components/invoice-for-report-only/invoice-for-report-only.component";
import { InvoiceForReportComponent } from "src/app/shared/components/invoice-for-report/invoice-for-report.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";

@Component({
  selector: "sm-all-unpaid-invoices",
  templateUrl: "./all-unpaid-invoices.component.html",
  styleUrls: ["./all-unpaid-invoices.component.scss"],
})
export class AllUnpaidInvoicesComponent implements OnInit, OnDestroy {
  unpaidInvoicesData: any = [];
  toshowData: boolean = true;
  loader: boolean = false;
  _apisub: Subscription;
  pageNo: number = 1;
  constructor(
    private navservice: NavigationService,
    private _apiservice: ApiService,
    private loaderservice: LoaderServiceService,
    private _modelRef: MatDialog,
    private dialogService: DialogService
  ) {
    this.navservice.hideSidebarAndNav = false;
    this._apisub = this._apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_LATEST_UNPAID_INVOICE_STATUS_FOR_DASHBOARD
      ) {
        this.unpaidInvoicesData = [];
        if (resdata.result) {
          resdata.result.forEach((element: any) => {
            element.cust_phone =
              element?.customer_country_code + " " + element?.customer_phone;
            element.i_amt = element?.currency_symbol + element?.amount.toFixed(2);
            element.i_due = element?.currency_symbol + element?.payment_due.toFixed(2);
            this.unpaidInvoicesData.push(element);
          });
        }
        console.log(this.unpaidInvoicesData);

        this.loaderservice.showLoader = false;
        this.loader = false;
      }
    });
  }

  ngOnInit(): void {
    this.loaderservice.showLoader = true;
    this.loader = true;
    this._apiservice.getLatestUnpaidInvoiceStatusForDashboard(
      this.pageNo,
      "500",
    );
  }

  // tableDisplayColumns: string[] = ['image', 'name', 'shop', 'payment', 'time', 'assigned', 'status'];

  bookingData = [
    {
      image:
        "https://www.bigbasket.com/media/uploads/p/l/20004724_11-pantene-advanced-hair-care-solution-shampoo-lively-clean.jpg",
      name: "Shampoo",
      quanty: "500 ml bottle",
      shop: "Mithali Hair Spa",
      location: "Bengal Ambuja Durgapur, West Bengal 713216",
      date: "2024-07-12",
      time: "3:00 PM",
      stock: "10 Bottle",
      amount: "999.00",
    },
    {
      image:
        "https://cdn.thewirecutter.com/wp-content/media/2023/04/sunscreen-2048px-09193.jpg?auto=webp&quality=75&width=1024",
      name: "Sunscreens",
      quanty: "500 ml bottle",
      shop: "Mithali Hair Spa",
      location: "Bengal Ambuja Durgapur, West Bengal 713216",
      date: "2024-07-12",
      time: "3:00 PM",
      stock: "10 Bottle",
      amount: "1266.00",
    },
    {
      image:
        "https://m.media-amazon.com/images/I/616kViYpgpL._AC_UF1000,1000_QL80_.jpg",
      name: "Eye shadows",
      quanty: "4 Unit",
      shop: "Mithali Hair Spa",
      location: "Bengal Ambuja Durgapur, West Bengal 713216",
      date: "2024-07-12",
      time: "3:00 PM",
      stock: "20 Unit",
      amount: "200.00",
    },
    {
      image:
        "https://cdn.pixelspray.io/v2/black-bread-289bfa/TIw66q/wrkr/t.resize(h:1240,w:1400)/data/Westelm/04Nov2020/7543848_7.jpg",
      name: "Towels",
      quanty: "4 Unit",
      shop: "Mithali Hair Spa",
      location: "Bengal Ambuja Durgapur, West Bengal 713216",
      date: "2024-07-12",
      time: "3:00 PM",
      stock: "10 Bottle",
      amount: "178.00",
    },
    {
      image:
        "https://rukminim2.flixcart.com/image/750/900/kxp0mfk0/makeup-apron/o/m/1/set-of-2-pcs-unisex-nylon-waterproof-machine-washable-original-imaga3dgdkjddgt8.jpeg?q=20&crop=false",
      name: "Aplon",
      quanty: "11 Unit",
      shop: "Mithali Hair Spa",
      location: "Bengal Ambuja Durgapur, West Bengal 713216",
      date: "2024-07-12",
      time: "3:00 PM",
      stock: "10 Bottle",
      amount: "999.00",
    },
    {
      image:
        "https://www.jpscissors.com/cdn/shop/articles/what-are-the-differences-between-shears-scissors-927962_1200x.jpg?v=1663030248",
      name: "Shears and scissors",
      quanty: "1 Unit",
      shop: "Mithali Hair Spa",
      location: "Bengal Ambuja Durgapur, West Bengal 713216",
      date: "2024-07-12",
      time: "3:00 PM",
      stock: "10 Bottle",
      amount: "444.00",
    },
    {
      image:
        "https://rukminim2.flixcart.com/image/850/1000/kj36ky80-0/hair-dryer/w/u/f/3500watt-high-quality-salon-grade-professional-hair-dryer-with-original-imafyqjp3qbrgkfu.jpeg?q=20&crop=false",
      name: "Hairdryers",
      quanty: "500 ml bottle",
      shop: "Mithali Hair Spa",
      location: "Bengal Ambuja Durgapur, West Bengal 713216",
      date: "2024-07-12",
      time: "3:00 PM",
      stock: "10 Unit",
      amount: "1299.00",
    },
  ];

  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "item_name",
    },
    {
      columnName: "quantity info",
      columnProperty: "quantity_info",
    },
    {
      columnName: "shop",
      columnProperty: "name",
    },
    {
      columnName: "location",
      columnProperty: "address_line",
    },
    {
      columnName: "date",
      columnProperty: "purchase_date",
    },
    // {
    //   columnName: "time",
    //   columnProperty: "time"
    // },

    {
      columnName: "purchase quantity",
      columnProperty: "activity",
    },

    {
      columnName: "amount",
      columnProperty: "purchase_price",
    },
  ];
  ngOnDestroy(): void {
    this._apisub.unsubscribe();
  }

  openInvoice(item: any) {
    let isEntityForeign = item.currency == "INR" ? "0" : "1";
    localStorage.setItem(SM_CONSTANTS.IS_ENTITY_FOREIGN, isEntityForeign);
    
    if (item.bookingHashId) {
      let data = {
        title: "Invoice",
        ref: this._modelRef,
        data: item.bookingHashId,
      };
      this.dialogService.openFullScreenDialog(InvoiceForReportComponent, data);
    } else {
      let data1 = {
        title: "Invoice",
        ref: this._modelRef,
        data: item.hash_id,
        entityHash: item.entityHash,
      };
      this.dialogService.openFullScreenDialog(
        InvoiceForReportOnlyComponent,
        data1,
      );
    }
  }
}
